module.exports = __webpack_public_path__ + "img/chart-display.dfe47397.svg";